import type { AuthError } from "./types";

export function taggedAuthError(authError: AuthError): Error & { authError: AuthError } {
  const message = "message" in authError ? authError.message : `Permission denied: ${authError.permission}`;
  return Object.assign(new Error(message), { authError });
}
